import React, { useState } from "react";
import { Collapse } from "../../../components/collapse";
import { Input } from "antd";
import Button from "../../../components/Button";

type MoreOptionsProps = {
  setPeEstimate: Function;
  setEpsGrowth: Function;
  handleGEnerate: Function;
  epsGrowth: string;
  peEstimatea: String;
  primaryStock: any;
  secondaryStocks: any;
};
export const MoreOptions = (props: MoreOptionsProps) => {
  return (
    <Collapse title="More Options">
      <div className="flex gap-3 items-end">
        <div className="flex flex-col gap-y-[6px]">
          <label htmlFor="pe-estimate" className="text-sm font-medium font-dm">
            PE Estimate
          </label>
          <Input
            id="pe-estimate"
            type="text"
            placeholder="Enter value"
            className="border border-[#D0D5DD] rounded-md p-2 w-full"
            onChange={(e) => props.setPeEstimate(e.target.value)}
          />
        </div>
        <div className="flex flex-col gap-y-[6px]">
          <label htmlFor="eps-growth" className="text-sm font-medium font-dm">
            EPS Growth Estimate (%)
          </label>
          <Input
            id="eps-growth"
            type="text"
            placeholder="Enter value"
            className="border border-[#D0D5DD] rounded-md p-2 w-full"
            onChange={(e) => props.setEpsGrowth(e.target.value)}
          />
        </div>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded-full font-dm hover:bg-blue-600 disabled:cursor-not-allowed disabled:bg-gray-300"
          onClick={() => {
            props.handleGEnerate(
              props.primaryStock,
              props.secondaryStocks,
              props.peEstimatea,
              props.epsGrowth
            );
          }}
          disabled={
            (!props.primaryStock && props.secondaryStocks.length !== 0) ||
            (!props.peEstimatea && !props.epsGrowth)
          }
        >
          Save
        </button>
      </div>
    </Collapse>
  );
};
